import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  avatar: string;
  id: number;
};

function OfferEstateBuyer({ name, avatar, id }: Props) {
  const { t } = useTranslation("offer");

  return (
    <div className="flex items-center h-14 py-2.5 pl-2.5 pr-5 bg-gray/10 rounded-2xl border-[1px] border-dashed border-[#1A1A1A]">
      <img src={avatar} alt="" className="size-[2.3125rem] rounded-2xl" />
      <div className="flex flex-col gap-1.5 ml-2.5">
        <p className="text-16 font-bold leading-none">{name}</p>
        <p className="text-12 font-bold text-white/50 leading-none">sID: {id}</p>
      </div>
      <p className="ml-auto text-11 font-medium text-gray/60 uppercase">{t("offer.buyer")}</p>
    </div>
  );
}

export default OfferEstateBuyer;
